import Vue from 'vue';
import Vuex from 'vuex';
import CORE_STATE from './modules/core.store';
import CUSTOMER_SERVICE_STATE from './modules/customer-service.store';
import ACCOUNT_STATE from './modules/account.store';
import PAYMENT_METHODS_STATE from './modules/payment-methods.store';
import BANKING_STATE from './modules/banking.store';
import DOCUMENT_STATE from './modules/documents.store';
import PROVIDERS_STATE from './modules/providers.store';
import PERSONAL_INFORMATION_STATE from './modules/personal-information.store';
import STATEMENTS_STATE from './modules/statement.store';
import CLAIM_STATE from './modules/claim.store';
import REFERENCE_STATE from './modules/reference.store';
import MEMBER_STATE from './modules/member-api.store';
import GROUP_STATE from './modules/group-api.store';
import VAULT_STATE from './modules/vault-api.store';
import TOTAL_ITEMS_STATE from './modules/total-items.store';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    CORE_STATE,
    CUSTOMER_SERVICE_STATE,
    ACCOUNT_STATE,
    PAYMENT_METHODS_STATE,
    BANKING_STATE,
    DOCUMENT_STATE,
    PROVIDERS_STATE,
    PERSONAL_INFORMATION_STATE,
    STATEMENTS_STATE,
    CLAIM_STATE,
    REFERENCE_STATE,
    MEMBER_STATE,
    GROUP_STATE,
    VAULT_STATE,
    TOTAL_ITEMS_STATE,
  },
});
